<template>
  <div class="lang-switcher">
    <button
      v-for="lang in langs"
      :key="lang"
      class="lang-switcher__btn"
      :class="{ 'lang-switcher__btn--active': currentLang === lang }"
      @click="switchLang(lang)"
    >
      {{ lang.toUpperCase() }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'LangSwitcher',
  data() {
    return { langs: ['de', 'en'] }
  },
  computed: {
    currentLang() {
      return this.$i18n.locale
    },
  },
  methods: {
    switchLang(lang) {
      this.$i18n.locale = lang
      this.$router.replace({ params: { lang } }).catch(() => {})
    },
  },
}
</script>

<style lang="scss" scoped>
.lang-switcher {
  display: flex;
  gap: 4px;
  background: rgba(255, 255, 255, 0.06);
  border-radius: 8px;
  padding: 3px;

  &__btn {
    padding: 5px 12px;
    border: none;
    border-radius: 6px;
    background: transparent;
    color: rgba(255, 255, 255, 0.4);
    font-size: 0.72rem;
    font-weight: 600;
    letter-spacing: 0.05em;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      color: rgba(255, 255, 255, 0.7);
    }

    &--active {
      background: rgba(208, 176, 146, 0.2);
      color: var(--gold-light);
    }
  }
}
</style>
